export default {
  zh: {
    copyright: 'The copyright of this event belongs to App',
    documentTitle: '等级',
    nav1: '财富等级',
    nav2: '魅力等级',
    nav3: '活跃',
    nav4: '红宝石等级',
    Current: '当前经验值',
    Next: '下一等级经验值',
    range: '等级区间(Lv.)',
    icons: '等级图标',
    effects: '进场特效',
    upgrade: '如何升级？',
    Gifts: '送礼物',
    Aristocracy: '购买贵族',
    Mounts: '购买坐骑',
    Headdress: '购买头像框',
    Go: 'Go',
    Note: '注：需花费金币购买或赠送才会累积经验值，1金币=1经验值',
    Receiving: '接收礼物',
    Note2: '注：收到礼物可累积经验值，1金币 = 1经验值',
    Experience: '需要AAA经验值到达等级BBB',
    Earn: '通过完成以下获得经验',
    mic: '用麦克风聊天',
    Minute: '分钟',
    round: '回合',
    Coins: '金币',
    lucky: '玩幸运轮 x 10 次',
    sendGift: '送礼物',
    refreshed: '此活动在 KSA 时间 00:00 刷新',
    sign: '活动签到',
    medal: '活动勋章',
    headwear: '活动头饰',
    mount: '活动座驾',
    days:"天",
  },
  en: {
    copyright: 'The copyright of this event belongs to App',
    documentTitle: 'Level',
    nav1: 'Wealth level',
    nav2: 'Charm level',
    nav3: 'Active',
    nav4: 'Ruby Level',
    Current: 'Current experience',
    Next: 'Next level experience',
    range: 'Level range(Lv.)',
    icons: 'Level icon',
    effects: 'Entry effect',
    upgrade: 'How to upgrade?',
    Gifts: 'Send Gift',
    Aristocracy: 'Buy Aristocracy',
    Mounts: 'Buy Mount',
    Headdress: 'Buy Headwear',
    Go: 'Go',
    Note:
      'Note：you need to spend gold coins purchasing or sending to increase experience value,1 gold coin = 1 experience value',
    Receiving: 'Receive gift',
    Note2: 'Note：Receiving gift can increase experience value. 1 gold coin = 1 experience value',
    Experience: 'Need AAA experience to LV BBB',
    Earn: 'Earn EXP by completing the following',
    mic: 'Chat on mic',
    Minute: 'Minute',
    round: 'round',
    Coins: 'Coins',
    lucky: 'Play the lucky wheel x 10 times',
    sendGift: 'Send gifts',
    refreshed: 'This activity is refreshed at 00:00 KSA time',
    sign: 'Activity sign in',
    medal: 'Activity medal',
    headwear: 'Activity headwear',
    mount: 'Activity mount',
    days:"days",
  },
  ar: {
    copyright: '',
    documentTitle: 'مستوى',
    nav1: 'مستوى الثروة',
    nav2: 'مستوى الجاذبية',
    nav3: 'نشيط',
    nav4: 'مستوى الياقوت',
    Current: 'قيمة الخبرة الحالية',
    Next: 'قيمة الخبرة في المستوى القادم',
    range: '(Lv.)نطاق المستوى',
    icons: 'أيقونة المستوى',
    effects: 'تأثير الدخول',
    upgrade: 'كيف رفع المستوى؟',
    Gifts: 'إرسال الهدية',
    Aristocracy: 'إشتراء الإستقراطية',
    Mounts: 'إشتراء الركوب',
    Headdress: 'إشتراء الإيطار',
    Go: 'ذهب',
    Note: 'الملاحظة: تحتاج إلى إنفاق الكوينز للشراء أو هدية لتجميع نقاط الخبرة ، كوينز واحدة = قيمة خبرة واحدة',
    Receiving: 'استلام الهدية',
    Note2: 'الملاحظة:إن إستلام الهدية يمكن تجميع نقاط الخبرة ، كوينز واحدة = قيمة خبرة واحدة',
    Experience: 'تحتاج AAA خبره الى BBB',
    Earn: 'اكسب خبرة بإكمال ما يلي',
    mic: 'الدردشة على الميكروفون',
    Minute: 'اللحظة',
    round: 'دائري',
    Coins: 'عملات معدنية',
    lucky: 'العب عجلة الحظ × 10 مرات',
    sendGift: 'أرسل هدايا',
    refreshed: 'يتم تحديث هذا النشاط في تمام الساعة 00:00 بتوقيت السعودية',
    sign: 'نشاط تسجيل الدخول',
    medal: 'ميدالية النشاط',
    headwear: 'أغطية الرأس النشاط',
    mount: 'جبل النشاط',
    days:"أيام",
  },
  tr: {
    copyright: "",
    documentTitle: 'Seviye',
    nav1: 'Servet seviyesi',
    nav2: 'Cazibe seviyesi',
    nav3: 'Aktiflik seviyesi',
    nav4: 'Yakut seviyesi',
    Current: 'Şu anki seviye puanı',
    Next: 'Bir sonraki seviye puanı',
    range: 'Seviye aralığı(Sv.)',
    icons: 'Seviye simgesi',
    effects: 'Giriş efektleri',
    upgrade: 'Nasıl seviye yükseltir？',
    Gifts: 'Hediye gönder',
    Aristocracy: 'Aristokrasi al',
    Mounts: 'Araç al',
    Headdress: 'Çerçeve al',
    Go: 'Git',
    Note: 'Not: sadece altın harcayarak satın alma ya da hediye etme seviye puanı kazandırır. 1 altın = 1 seviye puanı',
    Receiving: 'Hediye al',
    Note2: 'Not: Hediye alarak puan kazanabilir. 1 altın =1 puan',
    Experience: 'Lv BBB için AAA deneyimine ihtiyacınız var',
    Earn: 'Aşağıdakileri tamamlayarak EXP kazanın',
    mic: 'mikrofonla sohbet et',
    Minute: 'Dakika',
    round: 'Kez Şanslı Çark',
    Coins: 'Altınlık Hediye Gönderme',
    lucky: 'Şans çarkını 10 kez oyna',
    sendGift: 'Hediyeler göndermek',
    refreshed: 'Bu Aktivite 00:00 Satinde Yenilenir',
    sign: 'Oturum Açma Ödülleri',
    medal: 'Etkinlik madalyası',
    headwear: 'Aktiflik Cerceveler',
    mount: 'Aktiflik Araclarl',
    days:"gün",
  },
  jp: {
    copyright: 'The copyright of this event belongs to App',
    documentTitle: 'Level',
    nav1: 'Wealth level',
    nav2: 'Charm level',
    nav3: 'アクティブ',
    Current: 'Current experience',
    Next: 'Next level experience',
    range: 'Level range(Lv.)',
    icons: 'Level icon',
    effects: 'Entry effect',
    upgrade: 'How to upgrade?',
    Gifts: 'Send Gift',
    Aristocracy: 'Buy Aristocracy',
    Mounts: 'Buy Mount',
    Headdress: 'Buy Headwear',
    Go: 'Go',
    Note:
      'Note：you need to spend gold coins purchasing or sending to increase experience value,1 gold coin = 1 experience value',
    Receiving: 'Receive gift',
    Note2: 'Note：Receiving gift can increase experience value. 1 gold coin = 1 experience value',
    Experience: 'Need AAA experience to Lv BBB',
    Earn: '以下を完了することでEXPを獲得できます',
    mic: 'マイクでチャット',
    Minute: '分',
    round: '円形',
    Coins: 'コイン',
    lucky: 'ラッキーホイールを10回プレイする',
    sendGift: '贈り物を送る',
    refreshed: 'このアクティビティは00:00KSA時間に更新されます',
    sign: 'アクティビティサインイン',
    medal: '活動メダル',
    headwear: 'アクティビティヘッドウェア',
    mount: 'アクティビティマウント',
    days:"days",
  },
  uz:{
    "copyright": "Ushbu tadbirning mualliflik huquqi App ga tegishli",
    "documentTitle": "Daraja",
    "nav1": "Boylik darajasi",
    "nav2": "Joziba darajasi",
    "nav3": "Faollik",
    "nav4": "Ruby darajasi",
    "Current": "Joriy tajriba",
    "Next": "Keyingi daraja tajribasi",
    "range": "Daraja diapazoni (Lv.)",
    "icons": "Daraja belgisi",
    "effects": "Kirish effekti",
    "upgrade": "Qanday qilib yangilash mumkin?",
    "Gifts": "Sovg'a yuborish",
    "Aristocracy": "Zodagonlik sotib olish",
    "Mounts": "Uloq sotib olish",
    "Headdress": "Bosh kiyim sotib olish",
    "Go": "O'tish",
    "Note": "Eslatma: Tajriba qiymatini oshirish uchun oltin tanga sotib olish yoki yuborish kerak, 1 oltin tanga = 1 tajriba qiymati",
    "Receiving": "Sovg'ani qabul qilish",
    "Note2": "Eslatma: Sovg'ani qabul qilish tajriba qiymatini oshiradi. 1 oltin tanga = 1 tajriba qiymati",
    "Experience": "LV BBB ga o'tish uchun AAA tajriba kerak",
    "Earn": "Quyidagilarni bajarib tajriba to'plang",
    "mic": "Mikrofonda suhbatlashish",
    "Minute": "Daqiqa",
    "round": "davra",
    "Coins": "Tanga",
    "lucky": "Omadli g'ildirakni 10 marta aylantiring",
    "sendGift": "Sovg'alar yuborish",
    "refreshed": "Bu faoliyat KSA vaqti bilan 00:00 da yangilanadi",
    "sign": "Faoliyatga kirish",
    "medal": "Faoliyat medali",
    "headwear": "Faoliyat bosh kiyimi",
    "mount": "Faoliyat uloqi",
    "days": "kun"
},
    ru:{
    "copyright": "Авторские права на это событие принадлежат приложению",
    "documentTitle": "Уровень",
    "nav1": "Уровень богатства",
    "nav2": "Уровень очарования",
    "nav3": "Активность",
    "nav4": "Уровень рубина",
    "Current": "Текущий опыт",
    "Next": "Опыт следующего уровня",
    "range": "Диапазон уровней (Lv.)",
    "icons": "Иконка уровня",
    "effects": "Эффект при входе",
    "upgrade": "Как повысить уровень?",
    "Gifts": "Отправить подарок",
    "Aristocracy": "Купить аристократию",
    "Mounts": "Купить ездовое животное",
    "Headdress": "Купить головной убор",
    "Go": "Перейти",
    "Note": "Примечание: для увеличения опыта необходимо тратить золотые монеты на покупки или отправку. 1 золотая монета = 1 единица опыта",
    "Receiving": "Получить подарок",
    "Note2": "Примечание: получение подарка увеличивает опыт. 1 золотая монета = 1 единица опыта",
    "Experience": "Необходимо AAA опыта для LV BBB",
    "Earn": "Зарабатывайте опыт, выполняя следующие действия",
    "mic": "Общение в голосовом чате",
    "Minute": "Минута",
    "round": "Раунд",
    "Coins": "Монеты",
    "lucky": "Сыграйте в колесо удачи 10 раз",
    "sendGift": "Отправить подарки",
    "refreshed": "Эта активность обновляется в 00:00 по времени KSA",
    "sign": "Регистрация в активности",
    "medal": "Медаль активности",
    "headwear": "Головной убор активности",
    "mount": "Ездовое животное активности",
    "days": "дней"
},
    fa:{
    "copyright": "حق چاپ این رویداد متعلق به برنامه است",
    "documentTitle": "سطح",
    "nav1": "سطح ثروت",
    "nav2": "سطح جذابیت",
    "nav3": "فعال",
    "nav4": "سطح یاقوت",
    "Current": "تجربه فعلی",
    "Next": "تجربه سطح بعدی",
    "range": "محدوده سطح (Lv.)",
    "icons": "آیکون سطح",
    "effects": "اثر ورود",
    "upgrade": "چگونه سطح را ارتقا دهیم؟",
    "Gifts": "ارسال هدیه",
    "Aristocracy": "خرید اشرافیت",
    "Mounts": "خرید مرکب",
    "Headdress": "خرید سرپوش",
    "Go": "برو",
    "Note": "توجه: برای افزایش مقدار تجربه باید سکه‌های طلا خرج کنید یا ارسال کنید، ۱ سکه طلا = ۱ واحد تجربه",
    "Receiving": "دریافت هدیه",
    "Note2": "توجه: دریافت هدیه می‌تواند مقدار تجربه را افزایش دهد. ۱ سکه طلا = ۱ واحد تجربه",
    "Experience": "AAA تجربه مورد نیاز برای LV BBB",
    "Earn": "کسب تجربه با انجام موارد زیر",
    "mic": "چت صوتی",
    "Minute": "دقیقه",
    "round": "دور",
    "Coins": "سکه‌ها",
    "lucky": "۱۰ بار چرخاندن چرخ شانس",
    "sendGift": "ارسال هدایا",
    "refreshed": "این فعالیت در ساعت ۰۰:۰۰ به وقت KSA به‌روزرسانی می‌شود",
    "sign": "ثبت نام در فعالیت",
    "medal": "مدال فعالیت",
    "headwear": "سرپوش فعالیت",
    "mount": "مرکب فعالیت",
    "days": "روزها"
}


}



// WEBPACK FOOTER //
// src/pages/activity/level/lang.js